const DETAILS_ACCORDION_SELECTOR =
  '.section-faqs details, product-info .product__accordion details';
const DETAILS_PANEL_SELECTOR = '.faq-details__panel, .details-accordion__panel';

class DetailsAccordion {
  constructor(details) {
    this.details = details;
    this.summary = details.querySelector('summary');
    this.panel = details.querySelector(DETAILS_PANEL_SELECTOR);
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!this.summary || !this.panel) return;

    this.summary.setAttribute('aria-expanded', details.hasAttribute('open'));

    if (this.reducedMotion) return;

    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onTransitionEnd = this.onTransitionEnd.bind(this);

    this.summary.addEventListener('click', this.onSummaryClick);
  }

  onSummaryClick(event) {
    event.preventDefault();

    if (this.details.classList.contains('is-closing')) return;

    if (this.details.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.details.classList.remove('is-closing');
    this.details.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');

    // Keep the panel visually collapsed for one frame so the open transition can run.
    this.details.classList.add('is-opening');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.details.classList.remove('is-opening');
      });
    });
  }

  close() {
    this.details.classList.add('is-closing');
    this.panel.addEventListener('transitionend', this.onTransitionEnd);

    clearTimeout(this.closeFallbackTimer);
    this.closeFallbackTimer = window.setTimeout(() => {
      if (this.details.classList.contains('is-closing')) {
        this.finishClose();
      }
    }, 400);
  }

  onTransitionEnd(event) {
    if (event.target !== this.panel || event.propertyName !== 'grid-template-rows') return;

    this.finishClose();
  }

  finishClose() {
    clearTimeout(this.closeFallbackTimer);
    this.panel.removeEventListener('transitionend', this.onTransitionEnd);
    this.details.removeAttribute('open');
    this.details.classList.remove('is-closing');
    this.summary.setAttribute('aria-expanded', 'false');
  }
}

function initDetailsAccordions() {
  document.querySelectorAll(DETAILS_ACCORDION_SELECTOR).forEach((details) => {
    if (!details.dataset.detailsAccordionInit) {
      details.dataset.detailsAccordionInit = 'true';
      new DetailsAccordion(details);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDetailsAccordions);
} else {
  initDetailsAccordions();
}

document.addEventListener('shopify:section:load', initDetailsAccordions);
